import { Document } from '../entities/document';
import { DocumentDTO } from '../dtos/document.dto';

export class DocumentMapper {
  static toDTO(document: Document): DocumentDTO {
    return {
      id: document.id,
      projectId: document.project_id,
      projectSequenceId: document.project_sequence_id,
      title: document.title,
      content: document.content,
      type: document.type,
      status: document.status,
      approvedAt: document.approved_at,
      approvedById: document.approved_by_id,
      createdAt: document.created_at,
      updatedAt: document.updated_at,
      createdById: document.created_by_id,
      updatedById: document.updated_by_id,
      isLoading: document.is_loading,
      isOnboarding: document.is_onboarding
    };
  }
}